<template>
  <div class="dealers" v-if="dealers">
    <template v-if="(!popupEdit || !isMobile)">
      <h1 class="dealers__title">Дилеры</h1>
      <div class="dealers__head">
        <CopyLink
          class="dealers__offer"
          text="Ссылка-оффер для ваших дилеров"
          v-if="getDealer"
          :link="getDealer.link_offer ? getDealer.link_offer : ''"/>

        <DealerFilter
          :filter="filter" />
      </div>

      <Application
        v-for="(dealer, index) in notApprovedDealers"
        :key="index"
        :dealer="dealer"
        :index="index"
        :dealerData="dealerData"
        @updateApprovedDealers="pullNotApprovedDealers"
        @updateSubDealers="setDealers"
        @popupEditToggle="popupEditToggle" />

      <List
        :list="dealersFilter"
        :dealerData="dealerData"
        @popupEditToggle="popupEditToggle" />


      <div class="dealers__result">
        <div>
          <span>Итого:</span>
        </div>
        <div>Дилеров: {{ dealers.length }}</div>
        <div>Сотрудников: {{ dealersCount('employees_count') }}</div>
        <div>Субдилеров: {{ dealersCount('sub_dealers_count') }}</div>
      </div>
    </template>


    <Edit
      v-if="popupEdit"
      @popupToggle="popupEditToggle"
      :dealerData="dealerData" />
  </div>
</template>

<script>
import {
  mapActions,
  mapGetters,
  mapState,
} from 'vuex';

export default {
  name: "AccountDealers",

  components: {
    CopyLink: () => import('@/pages/account/components/CopyLink'),
    Application: () => import('./components/Application'),
    List: () => import('./components/list/List'),
    Edit: () => import('./components/Edit/Edit'),
    DealerFilter: () => import('./components/DealerFilter'),
  },

  data: () => ({
    filter: {
      employee: null,
      town: '',
    },
    application: false,
    popupEdit: false,
    dealerData: {
      info: null,
      save_and_approve: 0,
    },
  }),

  metaInfo() {
    return {
      title: `Дилеры - Личный кабинет дилера - ${this.getDealer.name}`,
    }
  },

  computed: {
    ...mapState({
      dealers: state => state.account.dealers.dealers,
      notApprovedDealers: state => state.account.dealers.not_approved_dealers,
      configAccess: state => state.user.configAccess,
    }),

    ...mapGetters('user', [
      'getDealer',
    ]),

    dealersFilter() {
      return this.dealers
        .filter(employee => {
          return this.filter.employee === null || employee.parent_dealer_employee_id === this.filter.employee.id;
        })

        .filter(town => {
          let city = !town.town ? '' : town.town;
          return this.filter.town === null || city.toLowerCase().indexOf(this.filter.town.toLowerCase()) !== -1;
        });
    },
  },

  methods: {
    ...mapActions('account/dealers', [
      'setDealers',
      'setNotApprovedDealers',
    ]),

    ...mapActions('account', [
      'pullEmployees',
    ]),

    dealerDeclineToggle() {
      this.application = !this.application;
    },

    dealersCount(type) {
      const dealers = this.dealers;
      let result = 0;
      for (const i in dealers) {
        result += dealers[i][type];
      }
      return result;
    },

    pullNotApprovedDealers() {
      this.setNotApprovedDealers();
    },

    popupEditToggle() {
      this.popupEdit = !this.popupEdit;
    },

    async fetchData() {
      await Promise.all([
        this.pullEmployees(),
        this.setDealers(),
        this.setNotApprovedDealers(),
      ])
        .finally(() => {
          this.togglePreload();
        });
    },
  },

  mounted() {
    this.togglePreload();
    this.fetchData();
  }
}
</script>

<style scoped lang="scss">
.dealers {
  padding: 0 15px 70px;

  @media(max-width: $desktop) {
    padding: 0 0 20px;
  }

  &__title {
    font-weight: bold;
    font-size: 24px;
    line-height: 30px;
    position: fixed;
    z-index: 120;
    left: 50%;
    transform: translateX(-50%);
    top: 0;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    height: 53px;
    margin: 0;

    @media(max-width: $desktop) {
      position: static;
      height: auto;
      transform: translateX(0);
      margin-bottom: 11px;
    }
  }

  &__head {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 32px;
    position: relative;

    @media(max-width: $desktop) {
      display: block;
      margin-bottom: 24px;
    }
  }

  &__caption {
    font-size: 14px;
    line-height: 18px;
    color: #979797;
    margin-bottom: 3px;
  }

  &__result {
    font-size: 12px;
    line-height: 15px;

    span {
      font-weight: bold;
    }
  }
}
</style>
